import { useRef, useState, useEffect, useCallback } from 'react';

/**
 * オーバーレイ上の検索ボタンの表示処理hooks
 * @returns 表示状態、表示処理
 */
export const useShowOverlay = () => {
  const observerRef = useRef<HTMLDivElement | null>(null);
  const [isOpacity, setIsOpacity] = useState(true);
  const [isInvisible, setIsInVisible] = useState(true);
  const [isChangedSearchCondition, setIsChangedSearchCondition] =
    useState(false);

  const onChangeIsShowOverlay = useCallback(() => {
    setIsChangedSearchCondition(true);
  }, []);

  useEffect(() => {
    // サイドバー状の検索ボタン表示エリアが表示された際にオーバーレイを非表示にする
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsOpacity(true);
          setTimeout(() => {
            setIsInVisible(true);
          }, 400);
        } else if (isChangedSearchCondition) {
          // サイドバー上で検索条件を変更したときのみ表示する
          setIsInVisible(false);
          // 前の処理を待ってから実行させる
          setTimeout(() => {
            setIsOpacity(false);
          });
        }
      },
      { threshold: 0.5 }
    );

    if (!observerRef.current) return;

    observer.observe(observerRef.current);

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, [isChangedSearchCondition]);

  return {
    observerRef,
    isOpacity,
    isInvisible,
    onChangeIsShowOverlay,
    isChangedSearchCondition,
  };
};
